var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('b',[_vm._v(" "+_vm._s(_vm.defaultFrequencyLabel)+": "),_c('common-highlight',{attrs:{"content":_vm.dayNames}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }